export default class DataTable {

    constructor() {
        this.init();
        this.hoverRow();
        this.deleteRow();
        this.restoreRow();
        this.export();
        this.initFilters();
        this.resetFilters();
        this.columnsVisibilityFilter();
        this.tableViewFilter();
    }

    /**
     * Tooltip nativo (attributo title) solo sulle celle il cui testo è troncato da ellipsis.
     */
    applyOverflowCellTitles(root) {
        const $scope = root instanceof $ ? root : $(root);
        const skipClasses = ['dt_col_actions', 'dt_col_checkbox'];

        $scope.find('tbody td').each(function () {
            const $cell = $(this);
            const el = this;

            if (skipClasses.some((cls) => $cell.hasClass(cls))) {
                $cell.removeAttr('title');
                return;
            }

            if ($cell.find('input, textarea, select, button, .btn, a.btn').length) {
                $cell.removeAttr('title');
                return;
            }

            const fullText = ($cell.attr('data-full-text') || $cell.text()).replace(/\s+/g, ' ').trim();
            if (!fullText) {
                $cell.removeAttr('title');
                return;
            }

            if (el.scrollWidth > el.clientWidth + 1) {
                $cell.attr('title', fullText);
            } else {
                $cell.removeAttr('title');
            }
        });
    }

    config() {
        const dtObject = this;
        // Aggiungo plugin per ordinamento date italiane DD/MM/YYYY
        $.fn.dataTable.moment = $.fn.dataTable.moment || function ( format, locale ) {
            var types = $.fn.dataTable.ext.type;
         
            // Add type detection
            types.detect.unshift( function ( d ) {
                if ( d ) {
                    // Strip HTML tags if present
                    d = d.replace ? d.replace( /<.*?>/g, "" ) : d;
                    
                    // Try to parse with moment
                    if ( moment ) {
                        var momentObj = locale ? moment( d, format, locale, true ) : moment( d, format, true );
                        return momentObj.isValid() ? 'moment-'+format : null;
                    }
                }
                return null;
            } );
         
            // Add sorting method - use an integer for the sorting
            types.order[ 'moment-'+format+'-pre' ] = function ( d ) {
                if ( d ) {
                    d = d.replace ? d.replace( /<.*?>/g, "" ) : d;
                    var momentObj = locale ? moment( d, format, locale, true ) : moment( d, format, true );
                    return momentObj.isValid() ? momentObj.valueOf() : -Infinity;
                }
                return -Infinity;
            };
        };
        
        // Attiva il plugin per le date italiane
        if (typeof moment !== 'undefined') {
            $.fn.dataTable.moment('DD/MM/YYYY');
            $.fn.dataTable.moment('DD/MM/YYYY HH:mm');
        }

        return {
            scrollY: '100vh',
            scrollCollapse: true,
            mark: {
                filter: function (node) {
                    var datatable = $(node.parentElement).closest('.dataTables_wrapper')
                    var datatableFilter = $('.datatable__filters th', datatable)
                        .eq($(node).closest("td").index())
                        .find('.datatable__filter');

                    if (
                        datatableFilter.hasClass('datatable__filter--select') ||
                        datatableFilter.hasClass('datatable__filter--select-multi') ||
                        datatableFilter.hasClass('datatable__filter--select-multi-ajax')
                    ) {
                        return false;
                    }
                    return true;
                }
            },
            scrollX: true,
            language: {
                url: '/js/admin-panel/vendor/dataTables/lang/' + $("html").attr("lang") + '.json'
            },
            rowCallback: function (row) {
                dtObject.applyOverflowCellTitles(row);
            },
            drawCallback: function (settings) {
                const tableId = settings && settings.sTableId;
                if (!tableId) {
                    return;
                }
                dtObject.updateSortIcons(tableId);
                dtObject.applyOverflowCellTitles($('#' + tableId));
            },
            ajax: {
                error: function (jqxhr, textStatus, thrownError) {
                    if (thrownError == 'Unauthorized' || jqxhr.status == 401 || jqxhr.status == 419) {
                        window.location.replace(routeLogin);
                    }
                }
            },

        }
    }

    init() {
        let dtObject = this;
        $('.ajaxDataTable').each(function () {
            // Salta l'inizializzazione se la tabella ha l'attributo data-lazy-init
            // (utilizzato per tabelle in tab nascoste che verranno inizializzate quando la tab diventa visibile)
            if ($(this).attr('data-lazy-init') === 'true') {
                return; // Salta questa tabella
            }
            
            let initParams = JSON.parse($(this).attr('data-params'));
            if(dtObject.tablePageLenght(initParams.id)){
                initParams.pageLength = dtObject.tablePageLenght(initParams.id);

            }
            if (!initParams.hasOwnProperty('preventAutoDraw')) {
                dtObject.draw($(this));
            }
        });


        $('.clientDataTable').each(function () {
            $(this).dataTable($.extend(true, {}, this.config(), {}));
        });

        $(document).on('init.dt', function (e, settings) {
            var api = new $.fn.dataTable.Api(settings);


            if (typeof window.route_mass_crud_entries_destroy != 'undefined') {
                $('.clientDataTable, .ajaxDataTable').siblings('.actions').html('<a href="' + window.route_mass_crud_entries_destroy + '" class="btn btn-xs btn-danger js-delete-selected" style="margin-top:0.755em;margin-left: 20px;">' + _t('Delete selected') + '</a>');
            }


            var tableId = settings.sTableId;
            $("#" + tableId + "_filter input").unbind();
            $("#" + tableId + "_filter input").on('input', function (e, autoSelected) {
                if (autoSelected) {
                    api.search("");
                    return;
                }
                // If the length is 3 or more characters, or the user pressed ENTER, search
                if (this.value.length >= 3) {
                    // Call the API search function
                    api.search(this.value).draw();
                }
                // Ensure we clear the search if they backspace far enough
                if (this.value == "") {
                    api.search("").draw();
                }
                return;
            });
            $("#" + tableId + "_filter input").on('keyup', function (e, autoSelected) {
                if (autoSelected) {
                    api.search("");
                    return;
                }
                // If the length is 3 or more characters, or the user pressed ENTER, search
                if (e.keyCode == 13) {
                    // Call the API search function
                    api.search(this.value).draw();
                }
                return;
            });
        });

        $(document).on('expanded.pushMenu', function (evt) {
            dtObject.resize('.ajaxDataTable');
        })

        $(document).on('collapsed.pushMenu', function (evt) {
            dtObject.resize('.ajaxDataTable');
        })
    }

    hoverRow() {
        $(document).on('click', '.DTFC_LeftWrapper .dataTable tbody tr', function () {
            if ($(this).hasClass('selected')) {
                $(this).removeClass('selected');
                $(this).closest('.dataTables_wrapper').find(".dataTables_scrollBody .dataTable tbody tr").eq($(this).index())
                    .removeClass('selected');
            } else {
                $(this).removeClass('selected');
                $(this).addClass('selected');
                $(this).closest('.dataTables_wrapper').find(".dataTables_scrollBody .dataTable tbody tr").eq($(this).index())
                    .addClass('selected');
            }
        });

        $(document).on('click', '.dataTables_scrollBody .dataTable tbody tr', function () {
            if ($(this).hasClass('selected')) {
                $(this).removeClass('selected');
                $(this).closest('.dataTables_wrapper').find(".DTFC_LeftWrapper .dataTable tbody tr").eq($(this).index())
                    .removeClass('selected');
            } else {
                $(this).removeClass('selected');
                $(this).addClass('selected');
                $(this).closest('.dataTables_wrapper').find(".DTFC_LeftWrapper .dataTable tbody tr").eq($(this).index())
                    .addClass('selected');
            }
        });

        $(document).on('mouseover mouseout', '.DTFC_LeftWrapper .dataTable tbody tr', function () {
            if ($(this).hasClass('hovered')) {
                $(this).removeClass('hovered');
                $(this).closest('.dataTables_wrapper').find(".dataTables_scrollBody .dataTable tbody tr").eq($(this).index())
                    .removeClass('hovered');
            } else {
                $(this).removeClass('hovered');
                $(this).addClass('hovered');
                $(this).closest('.dataTables_wrapper').find(".dataTables_scrollBody .dataTable tbody tr").eq($(this).index())
                    .addClass('hovered');
            }
        });

        $(document).on('mouseover mouseout', '.dataTables_scrollBody .dataTable tbody tr', function () {
            if ($(this).hasClass('hovered')) {
                $(this).removeClass('hovered');
                $(this).closest('.dataTables_wrapper').find(".DTFC_LeftWrapper .dataTable tbody tr").eq($(this).index())
                    .removeClass('hovered');
            } else {
                $(this).removeClass('hovered');
                $(this).addClass('hovered');
                $(this).closest('.dataTables_wrapper').find(".DTFC_LeftWrapper .dataTable tbody tr").eq($(this).index())
                    .addClass('hovered');
            }
        });
    }

    deleteRow() {
        $(document).on('click', '.data-table-delete-single', function (evt) {
            evt.preventDefault();
            var form = $(this).parent('form');
            var canDeleteForever = $(this).data('can_delete_forever');
            var deletionReason = $(this).data('deletion_reason');
            var isDeleted = $(this).data('is_deleted');
            var button = $(this);

            var swalConfig = {
                text: _t('Are you sure you want to delete the selected item?'),
                icon: "warning",
                buttonsStyling: false,
                showCancelButton: true,
                cancelButtonText: _t('Cancel'),
                confirmButtonText: _t('Delete'),
                denyButtonText: _t('Delete forever'),
                customClass: {
                    confirmButton: 'btn btn-warning',
                    denyButton: 'btn btn-danger',
                    cancelButton: 'btn btn-default'
                }
            };
            if (isDeleted) {
                swalConfig.showConfirmButton = false;
            }
            if (canDeleteForever) {
                swalConfig.showDenyButton = true;
            }
            if (deletionReason) {
                swalConfig.input = 'textarea';
                swalConfig.inputPlaceholder = _t('Type your reason here...');
            }

            Swal.fire(swalConfig)
                .then(function (result) {
                    if (result.isConfirmed) {
                        form.find('.data-table-deletion-reason').val(result.value);
                        executeDeleteWithAjax(form, button, false, false);
                    } else if (canDeleteForever && result.isDenied) {
                        Swal.fire({
                            text: _t('Are you sure you want to delete forever the selected item?'),
                            icon: "warning",
                            buttonsStyling: false,
                            showCancelButton: true,
                            cancelButtonText: _t('Cancel'),
                            confirmButtonText: _t('Delete forever'),
                            customClass: {
                                confirmButton: 'btn btn-danger',
                                cancelButton: 'btn btn-default',
                            }
                        }).then(function (result) {
                            if (result.isConfirmed) {
                                form.find('.data-table-delete-single-forever').val(1);
                                executeDeleteWithAjax(form, button, true, false);
                            }
                        });
                    }
                });
        });

        /**
         * Esegue la richiesta di eliminazione via AJAX per gestire risposte speciali
         * (es. preventivi con offerte collegate)
         */
        function executeDeleteWithAjax(form, button, deleteForever, confirmDeleteOfferts) {
            var url = form.attr('action');
            var data = form.serializeArray();
            
            // Aggiungi flag per conferma eliminazione offerte
            if (confirmDeleteOfferts) {
                data.push({ name: 'confirm_delete_offerts', value: 1 });
            }

            $.ajax({
                type: 'POST',
                url: url,
                data: data,
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                },
                success: function(response) {
                    // Caso: richiede conferma per eliminare offerte collegate non approvate
                    if (response.requires_confirmation && response.has_unapproved_offerts) {
                        Swal.fire({
                            title: _t('Warning') + '!',
                            html: '<p>' + response.message + '</p>',
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#d33',
                            cancelButtonColor: '#3085d6',
                            confirmButtonText: _t('Yes, delete all'),
                            cancelButtonText: _t('Cancel'),
                            customClass: {
                                confirmButton: 'btn btn-danger',
                                cancelButton: 'btn btn-default'
                            },
                            buttonsStyling: false
                        }).then(function(result) {
                            if (result.isConfirmed) {
                                // Riprova con conferma
                                executeDeleteWithAjax(form, button, deleteForever, true);
                            }
                        });
                        return;
                    }

                    // Caso: status con progetti associati - richiede migrazione
                    if (response.requires_status_migration) {
                        var statusOptions = response.available_statuses.map(function(s) {
                            return '<option value="' + s.id + '">' + s.title + '</option>';
                        }).join('');

                        Swal.fire({
                            title: _t('Projects associated'),
                            html: '<p>' + response.message + '</p>' +
                                  '<select id="migrate-status-select" class="form-control" style="margin-top: 15px;">' +
                                  '<option value="">' + _t('Select a status') + '...</option>' +
                                  statusOptions +
                                  '</select>',
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonText: _t('Move and delete'),
                            cancelButtonText: _t('Cancel'),
                            customClass: {
                                confirmButton: 'btn btn-warning',
                                cancelButton: 'btn btn-default'
                            },
                            buttonsStyling: false,
                            preConfirm: function() {
                                var selectedStatus = document.getElementById('migrate-status-select').value;
                                if (!selectedStatus) {
                                    Swal.showValidationMessage(_t('Please select a status'));
                                    return false;
                                }
                                return selectedStatus;
                            }
                        }).then(function(result) {
                            if (result.isConfirmed && result.value) {
                                // Aggiungi l'ID dello status di destinazione e riprova
                                // Serializza il form e aggiungi il parametro di migrazione
                                var formDataString = form.serialize() + '&migrate_to_status_id=' + encodeURIComponent(result.value);
                                
                                $.ajax({
                                    type: 'POST',
                                    url: url,
                                    data: formDataString,
                                    headers: {
                                        'X-Requested-With': 'XMLHttpRequest'
                                    },
                                    success: function(migrateResponse) {
                                        // Ricarica la datatable
                                        if (typeof window.LaravelDataTables !== 'undefined') {
                                            var tableId = button.closest('table').attr('id');
                                            if (tableId && window.LaravelDataTables[tableId]) {
                                                window.LaravelDataTables[tableId].ajax.reload(null, false);
                                            } else {
                                                Object.keys(window.LaravelDataTables).forEach(function(key) {
                                                    window.LaravelDataTables[key].ajax.reload(null, false);
                                                });
                                            }
                                        }
                                        Swal.fire({
                                            title: _t('Deleted') + '!',
                                            text: migrateResponse.message || _t('Projects moved and status deleted successfully'),
                                            icon: 'success',
                                            timer: 2000,
                                            showConfirmButton: false
                                        });
                                    },
                                    error: function(xhr) {
                                        var errorMessage = _t('Error during deletion');
                                        if (xhr.responseJSON && xhr.responseJSON.message) {
                                            errorMessage = xhr.responseJSON.message;
                                        }
                                        Swal.fire({
                                            title: _t('Error'),
                                            text: errorMessage,
                                            icon: 'error'
                                        });
                                    }
                                });
                            }
                        });
                        return;
                    }

                    // Successo: ricarica la datatable
                    if (typeof window.LaravelDataTables !== 'undefined') {
                        // Trova la datatable più vicina e ricaricala
                        var tableId = button.closest('table').attr('id');
                        if (tableId && window.LaravelDataTables[tableId]) {
                            window.LaravelDataTables[tableId].ajax.reload(null, false);
                        } else {
                            // Fallback: ricarica tutte le datatable
                            Object.keys(window.LaravelDataTables).forEach(function(key) {
                                window.LaravelDataTables[key].ajax.reload(null, false);
                            });
                        }
                    }

                    // Mostra messaggio di successo
                    var successMsg = response.message || _t('Item deleted successfully');
                    Swal.fire({
                        title: _t('Deleted') + '!',
                        text: successMsg,
                        icon: 'success',
                        timer: 2000,
                        showConfirmButton: false
                    });
                },
                error: function(xhr) {
                    var errorMessage = _t('Error during deletion');

                    if (xhr.responseJSON) {
                        // Caso: offerte approvate bloccano l'eliminazione
                        if (xhr.responseJSON.has_approved_offerts) {
                            errorMessage = xhr.responseJSON.error;
                        } else if (xhr.responseJSON.error) {
                            errorMessage = xhr.responseJSON.error;
                        } else if (xhr.responseJSON.message) {
                            errorMessage = xhr.responseJSON.message;
                        }
                    }

                    Swal.fire({
                        title: _t('Error'),
                        text: errorMessage,
                        icon: 'error'
                    });
                }
            });
        }
    }

    restoreRow() {
        $(document).on('click', '.data-table-restore-single', function (evt) {
            evt.preventDefault();
            var form = $(this).parent('form');

            Swal.fire({
                text: _t('Are you sure you want to restore the selected item?'),
                icon: "warning",
                buttonsStyling: false,
                showCancelButton: true,
                cancelButtonText: _t('Cancel'),
                confirmButtonText: _t('Restore'),
                input: 'checkbox',
                inputPlaceholder: _t('Restore related records'),
                customClass: {
                    confirmButton: 'btn btn-success',
                    cancelButton: 'btn btn-default',
                }
            })
                .then(function (result) {
                    if (result.isConfirmed) {
                        if ($('#swal2-checkbox').prop('checked')) {
                            form.find('.data-table-restore-relations').val(1);
                        }
                        form.submit();
                    }
                });
        });
    }

    export() {
        $('.btn-export-dt').click(function (evt) {
            evt.preventDefault();
            let targetTable = $(this).data('target_table');

            let recordsDisplay = $('#' + targetTable).dataTable().api().page.info().recordsDisplay;
            const maxExportRows = 100000;

            if (recordsDisplay > maxExportRows) {
                Swal.fire({
                    text: _t("The maximum allowed number of rows that can be exported is :numRows", {
                        numRows: maxExportRows,
                    }),
                    icon: "warning",
                    showCancelButton: false,
                });

                return;
            }

            Swal.fire({
                text: _t('Are you sure you want to export the selected items?'),
                icon: "warning",
                buttonsStyling: false,
                showCancelButton: true,
                cancelButtonText: _t('Cancel'),
                confirmButtonText: _t('Yes'),
                customClass: {
                    confirmButton: 'btn btn-success',
                    cancelButton: 'btn btn-default',
                }
            }).then(function (result) {
                if (result.value) {
                    let params = $('#' + targetTable).dataTable().api().ajax.params();
                    let url = $('#' + targetTable).dataTable().api().ajax.url();
                    let visible = $('#' + targetTable).dataTable().api().columns().visible().toArray();
                    for (let column in params.columns) {
                        params.columns[column].visible = visible[column];
                    }

                    params.export = true;
                    params.length = -1;

                    $.ajax({
                        url: url,
                        method: 'POST',
                        data: params,
                        headers: {
                            'X-CSRF-TOKEN': window._token
                        },
                        success() {
                            Swal.fire({
                                html: _t("We've started exporting the selected items. You will receive an email notification when the export is complete.") + '<br/><br/><a href="/exports">' + _t('Go to Exports section') + '</a>',
                                icon: "success",
                                showCancelButton: false,
                            })
                        }
                    });
                }
            });
        });
    }

    initFilters(container) {
        var prefix = container ? container + ' ' : '';
        // I filtri possono essere sia nell'header che nella modale, quindi non limitiamo il selettore

        $(prefix + '.datatable__filter--select-multi').each(function () {
            let current = $(this);
            current.select2({
                language: $("html").attr("lang"),
                allowClear: true,
                cache: true,
                placeholder: current.data('placeholder') || '',
            });
        });

        $(document).on('change', prefix + '.datatable__filter--select-multi', function (evt, autoSelected) {
            if (autoSelected) {
                return;
            }

            // Se il campo è dentro una modale filtri, non applicare il filtro qui
            if ($(this).closest('.modal--filters').length > 0) {
                return;
            }

            let current = $(this);
            let values = $(current).val();
            let tableId = $(current).data('table_target');
            let targetTable = $('#' + tableId);
            let columnTarget = $(current).data('column_target');


            targetTable.dataTable()
                .api()
                .columns(columnTarget)
                .search(values.join('|'), true, false)
                .draw();
        });


        $(prefix + '.datatable__filter--select-multi-ajax').each(function () {
            let current = $(this);
            current.select2({
                language: $("html").attr("lang"),
                dropdownCssClass: "select2-" + current.attr("name"),
                ajax: {
                    url: function (params) {
                        return current.attr('data-url');
                    },
                    dataType: 'json',
                    delay: 250,
                    data: function (params) {
                        return {
                            needle: params.term, // search term
                        };
                    },
                    processResults: function (data) {
                        var selectobj = $.map(data, function (v) {
                            return {
                                'text': v[current.data('text_field')],
                                'id': v[current.data('id_field')] ? v[current.data('id_field')] : v['id'],
                            }
                        });
                        return {results: selectobj};
                    },
                    cache: true,
                    error: function (err) {

                    }
                },
                placeholder: current.data('placeholder') || '',
                minimumInputLength: 2,
                allowClear: true
            });
        });

        $(document).on('change', prefix + '.datatable__filter--select-multi-ajax', function (evt, autoSelected) {
            if (autoSelected) {
                return;
            }

            // Se il campo è dentro una modale filtri, non applicare il filtro qui
            if ($(this).closest('.modal--filters').length > 0) {
                return;
            }

            let current = $(this);
            let values = $(current).val();
            let tableId = $(current).data('table_target');
            let targetTable = $('#' + tableId);
            let columnTarget = $(current).data('column_target');

            targetTable.dataTable()
                .api()
                .columns(columnTarget)
                .search(values.join('|'), true, false)
                .draw();
        });

        $(prefix + '.datatable__filter--select').each(function () {
            let current = $(this);

            current.select2({
                language: $("html").attr("lang"),
                allowClear: true,
                cache: true,
                placeholder: current.data('placeholder') || '',
            });
        });

        $(document).on('change', prefix + '.datatable__filter--select', function (evt, autoSelected) {

            if (autoSelected) {
                return;
            }

            // Se il campo è dentro una modale filtri, non applicare il filtro qui
            if ($(this).closest('.modal--filters').length > 0) {
                return;
            }

            let current = $(this);
            let value = $(current).val();
            let tableId = $(current).data('table_target');
            let targetTable = $('#' + tableId);
            let columnTarget = $(current).data('column_target');
            current.trigger('change', true);

            // Re-inizializza il filtro select2 se è stato svuotato
            if (value === '') {
                current.select2({
                    language: $("html").attr("lang"),
                    allowClear: true,
                    cache: true,
                    placeholder: current.data('placeholder') || '',
                });
            }

            targetTable.dataTable()
                .api()
                .columns(columnTarget)
                .search(value)
                .draw();
        });

        $(prefix + '.datatable__filter--date-range-picker').each(function () {
            let current = $(this);
            let locale = $.extend(true, {}, daterangepickerLocale, {
                format: 'DD/MM/YYYY'
            });

            let options = {
                timePicker: false,
                showDropdowns: true,
                autoUpdateInput: false,
                showWeekNumbers: true,
                linkedCalendars: false,
                alwaysShowCalendars: true,
                locale: locale
            };

            current.daterangepicker(options);

            current.on('apply.daterangepicker', function (ev, picker) {
                $(this)
                    .val(picker.startDate.format(locale.format) + ' - ' + picker.endDate.format(locale.format))
                    .trigger('change');
            });

            current.on('cancel.daterangepicker', function (ev, picker) {
                $(this)
                    .val('')
                    .trigger('change');
            });
        });

        $(document).on('change', prefix + '.datatable__filter--date-range-picker', function (evt, autoSelected) {

            if (autoSelected) {
                return;
            }

            // Se il campo è dentro una modale filtri, non applicare il filtro qui
            if ($(this).closest('.modal--filters').length > 0) {
                return;
            }

            let current = $(this);
            let value = $(current).val();
            let tableId = $(current).data('table_target');
            let targetTable = $('#' + tableId);
            let columnTarget = $(current).data('column_target');

            targetTable.dataTable()
                .api()
                .columns(columnTarget)
                .search(value)
                .draw();
        });

        $(prefix + '.datatable__filter--datetime-range-picker').each(function () {
            let current = $(this);

            let options = {
                timePicker: true,
                timePicker24Hour: true,
                timePickerIncrement: 1,
                showDropdowns: true,
                autoUpdateInput: false,
                showWeekNumbers: true,
                linkedCalendars: false,
                alwaysShowCalendars: true,
                locale: daterangepickerLocale
            };

            current.daterangepicker(options);

            current.on('apply.daterangepicker', function (ev, picker) {
                $(this)
                    .val(picker.startDate.format(daterangepickerLocale.format) + ' - ' + picker.endDate.format(daterangepickerLocale.format))
                    .trigger('change');
            });

            current.on('cancel.daterangepicker', function (ev, picker) {
                $(this)
                    .val('')
                    .trigger('change');
            });
        });

        $(document).on('change', prefix + '.datatable__filter--datetime-range-picker', function (evt, autoSelected) {

            if (autoSelected) {
                return;
            }

            // Se il campo è dentro una modale filtri, non applicare il filtro qui
            if ($(this).closest('.modal--filters').length > 0) {
                return;
            }

            let current = $(this);
            let value = $(current).val();
            let tableId = $(current).data('table_target');
            let targetTable = $('#' + tableId);
            let columnTarget = $(current).data('column_target');

            targetTable.dataTable()
                .api()
                .columns(columnTarget)
                .search(value)
                .draw();
        });

        /**
         * Date picker
         */

        $(prefix + '.datatable__filter--date-picker').each(function () {
            let current = $(this);
            let locale = $.extend(true, {}, daterangepickerLocale, {
                format: 'DD/MM/YYYY'
            });

            let options = {
                timePicker: false,
                showDropdowns: true,
                autoUpdateInput: false,
                showWeekNumbers: true,
                linkedCalendars: false,
                alwaysShowCalendars: true,
                locale: locale,
                singleDatePicker: true,
            };

            current.daterangepicker(options);

            current.on('apply.daterangepicker', function (ev, picker) {
                $(this)
                    .val(picker.startDate.format(locale.format))
                    .trigger('change');
            });

            current.on('cancel.daterangepicker', function (ev, picker) {
                $(this)
                    .val('')
                    .trigger('change');
            });
        });

        $(document).on('change', prefix + '.datatable__filter--date-picker', function (evt, autoSelected) {

            if (autoSelected) {
                return;
            }

            // Se il campo è dentro una modale filtri, non applicare il filtro qui
            if ($(this).closest('.modal--filters').length > 0) {
                return;
            }

            let current = $(this);
            let value = $(current).val();
            let tableId = $(current).data('table_target');
            let targetTable = $('#' + tableId);
            let columnTarget = $(current).data('column_target');

            targetTable.dataTable()
                .api()
                .columns(columnTarget)
                .search(value)
                .draw();
        });

        /**
         * End date picker
         */

        /**
         * Datetime picker
         */

        $(prefix + '.datatable__filter--datetime-picker').each(function () {
            let current = $(this);
            let locale = $.extend(true, {}, daterangepickerLocale, {
                format: 'DD/MM/YYYY HH:mm'
            });

            let options = {
                timePicker: true,
                timePicker24Hour: true,
                timePickerIncrement: 1,
                showDropdowns: true,
                autoUpdateInput: false,
                showWeekNumbers: true,
                linkedCalendars: false,
                alwaysShowCalendars: true,
                locale: locale,
                singleDatePicker: true,
            };

            current.daterangepicker(options);

            current.on('apply.daterangepicker', function (ev, picker) {
                $(this)
                    .val(picker.startDate.format(locale.format))
                    .trigger('change');
            });

            current.on('cancel.daterangepicker', function (ev, picker) {
                $(this)
                    .val('')
                    .trigger('change');
            });
        });

        $(document).on('change', prefix + '.datatable__filter--datetime-picker', function (evt, autoSelected) {

            if (autoSelected) {
                return;
            }

            // Se il campo è dentro una modale filtri, non applicare il filtro qui
            if ($(this).closest('.modal--filters').length > 0) {
                return;
            }

            let current = $(this);
            let value = $(current).val();
            let tableId = $(current).data('table_target');
            let targetTable = $('#' + tableId);
            let columnTarget = $(current).data('column_target');

            targetTable.dataTable()
                .api()
                .columns(columnTarget)
                .search(value)
                .draw();
        });

        /**
         * End datetime picker
         */


        let searchText = (current) => {
            let value = $(current).val();
            let tableId = $(current).data('table_target');
            let targetTable = $('#' + tableId);
            let columnTarget = $(current).data('column_target');

            targetTable.dataTable()
                .api()
                .columns(columnTarget)
                .search(value)
                .draw();
        }

        $(document).on('input', prefix + '.datatable__filter--search', function (evt, autoSelected) {
            let current = $(this);
            if (autoSelected) {
                return;
            }

            // Se il campo è dentro una modale filtri, non applicare il filtro qui
            if ($(this).closest('.modal--filters').length > 0) {
                return;
            }

            if (current.val() != '') {
                return;
            }

            searchText(current);
        });

        $('body').on('keypress', prefix + '.datatable__filter--search', function (evt, autoSelected) {
            if (autoSelected) {
                return;
            }

            // Se il campo è dentro una modale filtri, non applicare il filtro qui
            // (sarà gestito dalla modale che applicherà tutti i filtri insieme)
            if ($(this).closest('.modal--filters').length > 0) {
                return;
            }

            if (evt.which != 13) {
                return;
            } else {
                evt.preventDefault();
            }

            let current = $(this);
            searchText(current);
        });

        let searchNumberRange = (current) => {
            let targetTable = $('#' + $(current).data('table_target'));
            let columnTarget = $(current).data('column_target');
            let min;
            let max;

            if (current.hasClass('datatable__filter--number-range_from')) {
                let maxInput = current.next('.datatable__filter--number-range_to');
                min = current.val() ? current.val() : null;
                max = maxInput.val() ? maxInput.val() : null;

                maxInput.attr('min', min);
            } else {
                let minInput = current.prev('.datatable__filter--number-range_from');
                max = current.val() ? current.val() : null;
                min = minInput.val() ? minInput.val() : null;

                minInput.attr('max', max);
            }

            targetTable.dataTable()
                .api()
                .columns(columnTarget)
                .search(min + "|" + max)
                .draw();
        };

        $('body').on('keypress', '.datatable__filter--number-range', function (evt, autoSelected) {
            if (autoSelected) {
                return;
            }

            // Se il campo è dentro una modale filtri, non applicare il filtro qui
            // (sarà gestito dalla modale che applicherà tutti i filtri insieme)
            if ($(this).closest('.modal--filters').length > 0) {
                return;
            }

            if (evt.which != 13) {
                return;
            } else {
                evt.preventDefault();
            }

            let current = $(this);
            searchNumberRange(current);
        });

        $('body').on('input', '.datatable__filter--number-range', function (evt, autoSelected) {
            let current = $(this);

            if (autoSelected) {
                return;
            }

            // Se il campo è dentro una modale filtri, non applicare il filtro qui
            if ($(this).closest('.modal--filters').length > 0) {
                return;
            }

            if (current.val() != '') {
                return;
            }

            searchNumberRange(current);
        });
    }

    resetFilters() {
        let dtObject = this;

        $('.btn-reset-filters-dt').on('click', function (evt) {
            evt.preventDefault();
            let tableID = $(this).data('target_table');
            let table = $('#' + tableID);

            localStorage.removeItem(tableID);

            dtObject.resetFiltersInputs(tableID);
            dtObject.resetColumnsVisibility(tableID);

            if ($.fn.DataTable.isDataTable(table)) {
                table.DataTable().destroy();
            }

            dtObject.draw(table);
        });
    }

    resetFiltersInputs(tableID) {
        // Reset filtri nell'header (metodo vecchio) e nella modale (metodo nuovo)
        $('input.datatable__filter[data-table_target="' + tableID + '"]').each(function () {
            $(this).val('');
            $(this).trigger('input', true);
        });
        $('select.datatable__filter[data-table_target="' + tableID + '"]').each(function () {
            var $select = $(this);
            
            // Se è un select2, resetta correttamente
            if ($select.hasClass('datatable__filter--select-multi') || 
                $select.hasClass('datatable__filter--select-multi-ajax') ||
                $select.hasClass('datatable__filter--select')) {
                // Reset select2
                $select.val(null).trigger('change');
            } else {
                // Reset select normale
                $select.val('');
                $select.trigger('change', true);
            }
        });
        $('#' + tableID + '_filter input').each(function () {
            $(this).val('');
            $(this).trigger('input', true);
        });
        
        // Reset anche i filtri nella modale (hanno il suffisso _modal)
        var modalId = '#' + tableID + 'FiltersModal';
        $(modalId).find('.datatable__filter').each(function () {
            var $filter = $(this);
            
            if ($filter.is('input')) {
                $filter.val('');
                $filter.trigger('input', true);
            } else if ($filter.is('select')) {
                // Se è un select2, resetta correttamente
                if ($filter.hasClass('datatable__filter--select-multi') || 
                    $filter.hasClass('datatable__filter--select-multi-ajax') ||
                    $filter.hasClass('datatable__filter--select')) {
                    // Reset select2 nella modale
                    $filter.val(null).trigger('change');
                } else {
                    // Reset select normale
                    $filter.val('');
                    $filter.trigger('change', true);
                }
            }
        });
        
        // Reset anche la tabella DataTable stessa
        if ($('#' + tableID).length && $.fn.DataTable.isDataTable('#' + tableID)) {
            var table = $('#' + tableID).DataTable();
            // Reset tutte le colonne della tabella
            table.columns().search('').draw();
        }
        
        // Aggiorna conteggio filtri dopo reset (desktop e mobile)
        var $filtersCountTextContent = $('#' + tableID + 'FiltersCountTextContent');
        var $filtersCountTextContentMobile = $('#' + tableID + 'FiltersCountTextContentMobile');
        if ($filtersCountTextContent.length) {
            $filtersCountTextContent.text('Nessun filtro applicato');
        }
        if ($filtersCountTextContentMobile.length) {
            $filtersCountTextContentMobile.text('Nessun filtro applicato');
        }
    }
    
    applyFiltersFromModal(tableID) {
        console.log('🔧 applyFiltersFromModal chiamato per:', tableID);
        
        var $table = $('#' + tableID);
        if (!$table.length || !$.fn.DataTable.isDataTable('#' + tableID)) {
            console.log('⚠️ Tabella non trovata o non è una DataTable:', tableID);
            return;
        }
        
        var table = $table.DataTable();
        var modalId = '#' + tableID + 'FiltersModal';
        var $modal = $(modalId);
        
        if (!$modal.length) {
            console.log('⚠️ Modale non trovata:', modalId);
            return;
        }
        
        console.log('📋 Trovati', $modal.find('.datatable__filter').length, 'filtri nella modale');
        
        // Applica tutti i filtri dalla modale senza trigger automatici
        var filtersApplied = 0;
        $modal.find('.datatable__filter').each(function () {
            var $filter = $(this);
            var columnTarget = $filter.data('column_target');
            var tableTarget = $filter.data('table_target');
            
            if (tableTarget !== tableID || !columnTarget) {
                return;
            }
            
            var filterType = '';
            var value = '';
            
            if ($filter.hasClass('datatable__filter--search')) {
                filterType = 'search';
                value = $filter.val() || '';
            } else if ($filter.hasClass('datatable__filter--select')) {
                filterType = 'select';
                value = $filter.val() || '';
            } else if ($filter.hasClass('datatable__filter--select-multi')) {
                filterType = 'select-multi';
                var values = $filter.val();
                value = values && values.length ? values.join('|') : '';
            } else if ($filter.hasClass('datatable__filter--select-multi-ajax')) {
                filterType = 'select-multi-ajax';
                var values = $filter.val();
                value = values && values.length ? values.join('|') : '';
            } else if ($filter.hasClass('datatable__filter--date-range-picker')) {
                filterType = 'date-range-picker';
                value = $filter.val() || '';
            } else if ($filter.hasClass('datatable__filter--datetime-range-picker')) {
                filterType = 'datetime-range-picker';
                value = $filter.val() || '';
            } else if ($filter.hasClass('datatable__filter--date-picker')) {
                filterType = 'date-picker';
                value = $filter.val() || '';
            } else if ($filter.hasClass('datatable__filter--datetime-picker')) {
                filterType = 'datetime-picker';
                value = $filter.val() || '';
            } else if ($filter.hasClass('datatable__filter--number-range_from')) {
                // Number range: gestito insieme (solo per _from)
                var $from = $filter;
                var $to = $filter.closest('.filter-item').find('.datatable__filter--number-range_to');
                var fromValue = $from.val() || '';
                var toValue = $to.length ? ($to.val() || '') : '';
                value = fromValue + '|' + toValue;
            } else if ($filter.hasClass('datatable__filter--number-range_to')) {
                // Salta il _to perché viene gestito insieme con _from
                return;
            }
            
            if (filterType && columnTarget) {
                if (value) {
                    console.log('  🔍 Filtro applicato:', filterType, 'colonna:', columnTarget, 'valore:', value);
                    filtersApplied++;
                }
                table.columns(columnTarget).search(value, true, false);
            }
        });
        
        console.log('✅ Applicati', filtersApplied, 'filtri. Chiamata a table.draw()...');
        table.draw();
        console.log('✅ Draw completato per tabella:', tableID);
        
        // Aggiorna conteggio filtri dopo aver applicato i filtri
        setTimeout(function() {
            var activeFiltersCount = 0;
            $modal.find('.datatable__filter').each(function() {
                var $filter = $(this);
                var value = $filter.val();
                
                if (value && value !== '' && value !== null) {
                    // Per select2 multi, controlla se ha valori selezionati
                    if ($filter.hasClass('datatable__filter--select-multi') || 
                        $filter.hasClass('datatable__filter--select-multi-ajax')) {
                        var values = $filter.val();
                        if (values && values.length > 0) {
                            activeFiltersCount++;
                        }
                    } else {
                        activeFiltersCount++;
                    }
                }
            });
            
            var $filtersCountTextContent = $('#' + tableID + 'FiltersCountTextContent');
            var $filtersCountTextContentMobile = $('#' + tableID + 'FiltersCountTextContentMobile');
            
            // Determina il testo in base al conteggio (0, 1 o plurale)
            var filterText = '';
            if (activeFiltersCount === 0) {
                filterText = 'Nessun filtro applicato';
            } else if (activeFiltersCount === 1) {
                filterText = '1 filtro applicato';
            } else {
                filterText = activeFiltersCount + ' filtri applicati';
            }
            
            if ($filtersCountTextContent.length) {
                $filtersCountTextContent.text(filterText);
            }
            if ($filtersCountTextContentMobile.length) {
                $filtersCountTextContentMobile.text(filterText);
            }
        }, 100);
    }

    resetColumnsVisibility(tableID) {
        let table = $('#' + tableID);
        let tableParams = JSON.parse(table.attr('data-params'));
        if(this.tablePageLenght(tableParams.id)){
            tableParams.pageLength = this.tablePageLenght(tableParams.id);
        }

        $(table).dataTable()
            .api()
            .columns()
            .visible(true, true);

        let checkboxes = $('.dt_col_visibility_filter[data-table_target="' + tableID + '"]');
        checkboxes.each(function () {
            let checkbox = $(this);
            $(tableParams.columns).each(function () {
                let column = this;
                if (checkbox.attr('id') == column.className) {
                    if (column.visible == undefined || column.visible) {
                        checkbox
                            .prop('checked', true)
                            .iCheck('update');
                    } else {
                        checkbox
                            .prop('checked', false)
                            .iCheck('update');
                    }
                }
            })
        })
    }

    toggleActions(tableId, disable) {
        $('.dt_save-view_btn[data-target_table="' + tableId + '"]').prop('disabled', disable);
        $('.dt_delete-view_btn[data-target_table="' + tableId + '"]').prop('disabled', disable);
        $('.select2-create_tag[data-target_table="' + tableId + '"]').prop('disabled', disable);
        $('button[data-target="#' + tableId + 'ColumnsVisibilityModal"]').prop('disabled', disable);
        $('button[data-target_table="' + tableId + '"]').prop('disabled', disable);
    }

    hideViewActions(tableId) {
        $('.dt_save-view_btn[data-target_table="' + tableId + '"]').hide();
        $('.dt_delete-view_btn[data-target_table="' + tableId + '"]').hide();
    }

    showViewActions(tableId) {
        $('.dt_save-view_btn[data-target_table="' + tableId + '"]').show();
        $('.dt_delete-view_btn[data-target_table="' + tableId + '"]').show();
    }

    toggleViewInfoMessage(tableId, display) {
        $('.datatable__view-info-message[data-target_table="' + tableId + '"]').css('display', display);
    }

    draw($table, calledFromTableView) {
        let tableId = $table.attr('id');
        let initParams = JSON.parse($table.attr('data-params'));
        let dtObject = this;

        // Recupera il valore di pageLength da local storage
        let savedParams = JSON.parse(localStorage.getItem(tableId));
        
        if (savedParams && savedParams.pageLength) {
            initParams.pageLength = savedParams.pageLength;
        }

        // Trasforma i nomi delle colonne di ordinamento in indici di colonna
        for (let i = 0; i < initParams.order.length; i++) {
            for (let j = 0; j < initParams.columns.length; j++) {
                if (initParams.order[i][0] == initParams.columns[j].data) {
                    initParams.order[i][0] = j.toString();
                    break;
                }
            }
        }

        // Filtra order: solo indici validi (evita aoColumns[srcCol] undefined anche senza localStorage)
        let numCols = initParams.columns.length;
        let orderValid = (Array.isArray(initParams.order) ? initParams.order : []).filter(function (o) {
            let idx = parseInt(o[0], 10);
            return !isNaN(idx) && idx >= 0 && idx < numCols;
        });
        if (orderValid.length === 0) {
            orderValid = [['0', 'asc']];
        }
        initParams.order = orderValid;

        let ignoreLocalStorage = true;
        let initSearchCols = [];
        let initVisibleCols = [];
        let initParamsTransformed = {
            order: _.map(initParams.order, function (i) {
                return [
                    i[0].toString(),
                    i[1]
                ]
            }),
            search: null,
            searchCols: [],
            visibleCols: [],
        };

        calledFromTableView = calledFromTableView || false;

        initParams.processing = true;
        initParams.serverSide = true;

        for (let ic in initParams.columns) {
            let column = initParams.columns[ic];
            if (column.hasOwnProperty('search')) {
                initSearchCols.push(column.search);
            } else {
                initSearchCols.push(null);
            }

            initVisibleCols.push({
                data: column.data,
                column_target: '.dt_col_' + column.data,
                visible: column.hasOwnProperty('visible') && !column.visible ? 'false' : 'true',
            });
        }

        initParams.searchCols = initSearchCols;
        initParamsTransformed.visibleCols = initVisibleCols;
        initParamsTransformed.searchCols = initSearchCols;

        if (calledFromTableView && localStorage.hasOwnProperty(tableId)) {
            ignoreLocalStorage = false;
        } else if (localStorage.hasOwnProperty(tableId) && (!initParams.hasOwnProperty('ignoreLocalStorage') || !initParams.ignoreLocalStorage)) {
            ignoreLocalStorage = false;
        }

        if (!ignoreLocalStorage) {
            let savedParams = JSON.parse(localStorage.getItem(tableId));
            let visibleCols = savedParams.hasOwnProperty('visibleCols') ? savedParams.visibleCols : null;

            initParams.searchCols = savedParams.searchCols;
            // Filtra order: solo indici colonna validi (evita aoColumns[srcCol] undefined dopo dedup colonne)
            let savedOrder = Array.isArray(savedParams.order) ? savedParams.order : [];
            let numCols = initParams.columns.length;
            initParams.order = savedOrder.filter(function (o) {
                let idx = parseInt(o[0], 10);
                return !isNaN(idx) && idx >= 0 && idx < numCols;
            });
            if (initParams.order.length === 0) {
                initParams.order = [['0', 'asc']];
            }
            initParams.search = {"search": savedParams.search};

            if (visibleCols) {
                for (let c in initParams.columns) {
                    let colData = initParams.columns[c].data;
                    let visible = true;
                    for (let k in visibleCols) {
                        if (visibleCols[k] && visibleCols[k].data === colData) {
                            visible = visibleCols[k].visible == 'false' || visibleCols[k].visible === false ? false : true;
                            break;
                        }
                    }
                    initParams.columns[c].visible = visible;
                }
                // Vista corrotta: se resta solo una colonna (o nessuna) visibile, mostra tutte
                let visibleCount = 0;
                for (let c in initParams.columns) {
                    if (initParams.columns[c].visible) visibleCount++;
                }
                if (visibleCount <= 1) {
                    for (let c in initParams.columns) {
                        initParams.columns[c].visible = true;
                    }
                }
            }
        }

        initParams.ajax.data.invisibleColumns = [];
        for (let ic in initParams.columns) {
            let column = initParams.columns[ic];
            if (column.hasOwnProperty('visible') && !column.visible) {
                initParams.ajax.data.invisibleColumns.push(column.data);
            }
        }

        let createdRowCallback = $table.data('created_row_callback');

        initParams = $.extend(true, {}, initParams, {
            createdRow: function (row, data, dataIndex) {
                if ($(data.deleted).data('is_deleted')) {
                    $(row).addClass('record-deleted');
                    $('td', row).addClass('record-deleted');
                }

                if (createdRowCallback) {
                    dtObject.onCreatedRow(createdRowCallback, row, data, dataIndex);
                }
            },
            initComplete: function (settings, json) {
                var $wrapper = $('#' + tableId).closest('.dataTables_wrapper');

                // Sposta il select pageLength nella toolbar panel-view
                var $lengthSlot = $('#' + tableId + '_pageLengthSlot');
                var $lengthSelect = $wrapper.find('.dataTables_length select');
                if ($lengthSlot.length && $lengthSelect.length) {
                    $lengthSelect.addClass('dt-pagelength-select');
                    $lengthSlot.append($lengthSelect).show();
                }

                // Sposta l'input di ricerca globale nella toolbar panel-view
                var $searchSlot = $('#' + tableId + '_globalSearchSlot');
                var $searchInput = $wrapper.find('.dataTables_filter input[type="search"]');
                if ($searchSlot.length && $searchInput.length) {
                    $searchInput.addClass('dt-global-search-input').attr('placeholder', 'Cerca...');
                    $searchSlot.append($searchInput).show();
                }

                // Nasconde la riga nativa DataTables (ormai vuota)
                $wrapper.children('.row').first().hide();

                dtObject.createFooter(initParams, tableId);
                dtObject.listenForChange(tableId);
                
                dtObject.disableSortingOnFilters(tableId);
                dtObject.updateSortIcons(tableId);
                
                let savedParams = JSON.parse(localStorage.getItem(tableId));
                if (savedParams && savedParams.pageLength) {
                    $('select[name=' + tableId + '_length]').val(savedParams.pageLength).trigger('change');
                }
            },
            drawCallback: function (settings) {
                // Ricalcola i totali quando la tabella viene ridisegnata (es. filtri applicati)
                // Controllo che il footer esista già per evitare conflitti di timing
                setTimeout(() => {
                    let table = $('#' + tableId);
                    let footerExists = false;
                    
                    // Controlla se il footer esiste (stesso controllo di calcTotals)
                    let footer = table.closest('.dataTables_scroll').find('.dataTables_scrollFoot table tfoot');
                    if (footer.length === 0) {
                        footerExists = table.find('tfoot tr').length > 0;
                    } else {
                        footerExists = footer.find('tr').length > 0;
                    }
                    
                    if (footerExists) {
                        dtObject.calcTotals(initParams, tableId);
                    }
                }, 100);

                dtObject.updateSortIcons(tableId);
                dtObject.applyOverflowCellTitles($('#' + tableId));
            }
        });

        let params = $.extend(true, {}, this.config(), initParams);

        let table = $table.DataTable(params);

        // CORREZIONE: Aggiungi event listener per ridimensionamento finestra
        $(window).on('resize.' + tableId, function() {
            if (table && table.columns) {
                table.columns.adjust(); // RIMOSSO .draw() per evitare loop infinito
                dtObject.applyOverflowCellTitles($('#' + tableId));
                console.log('🔧 Colonne ricalcolate per resize finestra:', tableId);
            }
        });

        table.on('preDraw', function () {
            dtObject.toggleActions(tableId, true);
        });

        table.on('draw', function (evt) {
            let api = $(this).dataTable().api();
            let params = api.ajax.params();
            let visible = api.columns().visible().toArray();

            // To been assigned in localstorage obj.
            let searchCols = [];
            let orderCols = [];
            let visibleCols = [];
            let search = null;

            for (let c in params.columns) {
                let column = params.columns[c];
                let column_target = '.dt_col_' + column.data;
                //Setup search pattern for each column
                if (column.hasOwnProperty('search') && column.search.hasOwnProperty('value') && column.search.value) {
                    // Search filer
                    let searchFilter = $('input.datatable__filter--search[data-column_target="' + column_target + '"][data-table_target="' + tableId + '"]');
                    // Select filter
                    let selectFilter = $('select.datatable__filter--select[data-column_target="' + column_target + '"][data-table_target="' + tableId + '"]');
                    // Multi select filter
                    let multiSelectFilter = $('select.datatable__filter--select-multi[data-column_target="' + column_target + '"][data-table_target="' + tableId + '"]');
                    // Multi select filter
                    let multiSelectAjaxFilter = $('select.datatable__filter--select-multi-ajax[data-column_target="' + column_target + '"][data-table_target="' + tableId + '"]');
                    // Date Range Picker filter
                    let dateRangePickerFilter = $('input.datatable__filter--date-range-picker[data-column_target="' + column_target + '"][data-table_target="' + tableId + '"]');
                    // DateTime Range Picker filter
                    let datetimeRangePickerFilter = $('input.datatable__filter--datetime-range-picker[data-column_target="' + column_target + '"][data-table_target="' + tableId + '"]');
                    // Date Picker filter
                    let datePickerFilter = $('input.datatable__filter--date-picker[data-column_target="' + column_target + '"][data-table_target="' + tableId + '"]');
                    // DateTime Picker filter
                    let datetimePickerFilter = $('input.datatable__filter--datetime-picker[data-column_target="' + column_target + '"][data-table_target="' + tableId + '"]');
                    //Number Range From Picker
                    let numberRangeFrom = $('input.datatable__filter--number-range_from[data-column_target="' + column_target + '"][data-table_target="' + tableId + '"]');
                    //Number Range To Picker
                    let numberRangeTo = $('input.datatable__filter--number-range_to[data-column_target="' + column_target + '"][data-table_target="' + tableId + '"]');

                    if (searchFilter.length) {
                        $(searchFilter).val(column.search.value);
                    }

                    if (selectFilter.length) {
                        $(selectFilter).val(column.search.value);
                        $(selectFilter).trigger('change', true);
                    }

                    if (multiSelectFilter.length) {
                        let valuesToArr = column.search.value.split('|');
                        $(multiSelectFilter).val(valuesToArr);
                        $(multiSelectFilter).trigger('change', true);
                    }
                    if (multiSelectAjaxFilter.length) {
                        let valuesToArr = column.search.value.split('|');
                        $.each(valuesToArr, function (i, value) {
                            if (!multiSelectAjaxFilter.find("option[value='" + value + "']").length) {
                                multiSelectAjaxFilter.append(new Option(value, value, true, true));
                            }
                        });
                        $(multiSelectAjaxFilter).val(valuesToArr);
                        $(multiSelectAjaxFilter).trigger('change', true);
                    }
                    if (dateRangePickerFilter.length) {
                        $(datetimeRangePickerFilter).val(column.search.value);
                    }
                    if (datetimeRangePickerFilter.length) {
                        $(datetimeRangePickerFilter).val(column.search.value);
                    }
                    if (datePickerFilter.length) {
                        $(datePickerFilter).val(column.search.value);
                    }
                    if (datetimePickerFilter.length) {
                        $(datetimePickerFilter).val(column.search.value);
                    }
                    if (numberRangeFrom.length) {
                        let numberRangeFromValuesToArr = column.search.value.split('|');
                        let numberRangeFromValue = numberRangeFromValuesToArr.hasOwnProperty(0)
                        && parseInt(numberRangeFromValuesToArr[0])
                            ? parseInt(numberRangeFromValuesToArr[0])
                            : null;

                        $(numberRangeFrom).val(numberRangeFromValue);
                    }

                    if (numberRangeTo.length) {
                        let numberRangeToValuesToArr = column.search.value.split('|');
                        let numberRangeToValue = numberRangeToValuesToArr.hasOwnProperty(1)
                        && parseInt(numberRangeToValuesToArr[1])
                            ? parseInt(numberRangeToValuesToArr[1])
                            : null;

                        $(numberRangeTo).val(numberRangeToValue);
                    }

                    // Assign search value for local storage object
                    searchCols[c] = {search: column.search.value};
                } else {
                    // Set search value to null for local storage object
                    searchCols[c] = null;
                }

                //Assign visibility of the column for local storage object
                visibleCols[c] = {
                    data: column.data,
                    column_target: column_target,
                    visible: visible[c] ? 'true' : 'false',
                };
            }

            if (params.hasOwnProperty('order')) {
                for (let o in params.order) {
                    let order = params.order[o];
                    if (order.hasOwnProperty('column') && order.hasOwnProperty('dir')) {
                        orderCols.push([order.column.toString(), order.dir]);
                    }
                }
            }

            if (params.hasOwnProperty('search')) {
                search = $.trim(params.search.value) == '' ? null : params.search.value;
            }

            let savedParams = localStorage.hasOwnProperty(tableId) ? JSON.parse(localStorage.getItem(tableId)) : {};
            let newParams = $.extend(true, {}, savedParams, {
                searchCols: searchCols,
                order: orderCols,
                search: search,
                visibleCols: visibleCols
            });
            newParams.order = orderCols;

            localStorage.setItem(tableId, JSON.stringify(newParams));

            dtObject.toggleActions(tableId, false);

            let paramsIsEqual = _.isEqual(
                _.omit(newParams, ['last_used_view']),
                _.omit(initParamsTransformed, ['last_used_view']),
            );

            // Conta filtri attivi
            let activeFiltersCount = 0;
            for (let c in params.columns) {
                let column = params.columns[c];
                if (column.hasOwnProperty('search') && column.search.hasOwnProperty('value') && column.search.value) {
                    activeFiltersCount++;
                }
            }
            
            // Aggiorna conteggio filtri accanto al pulsante (desktop e mobile)
            let $filtersCountText = $('#' + tableId + 'FiltersCountText');
            let $filtersCountTextContent = $('#' + tableId + 'FiltersCountTextContent');
            let $filtersCountTextMobile = $('#' + tableId + 'FiltersCountTextMobile');
            let $filtersCountTextContentMobile = $('#' + tableId + 'FiltersCountTextContentMobile');
            
            // Determina il testo in base al conteggio (0, 1 o plurale)
            let filterText = '';
            if (activeFiltersCount === 0) {
                filterText = 'Nessun filtro applicato';
            } else if (activeFiltersCount === 1) {
                filterText = '1 filtro applicato';
            } else {
                filterText = activeFiltersCount + ' filtri applicati';
            }
            
            if ($filtersCountTextContent.length) {
                $filtersCountTextContent.text(filterText);
            }
            if ($filtersCountTextContentMobile.length) {
                $filtersCountTextContentMobile.text(filterText);
            }
            
            // Rimosso alert filtri: ora usiamo il conteggio accanto al pulsante
            // if (!paramsIsEqual) {
            //     $('.' + tableId + 'FiltersAlert').css('display', 'block');
            //     dtObject.toggleViewInfoMessage(tableId, 'block');
            // } else {
            //     $('.' + tableId + 'FiltersAlert').css('display', 'none');
            //     dtObject.toggleViewInfoMessage(tableId, 'none');
            // }
            
            if (!paramsIsEqual) {
                dtObject.toggleViewInfoMessage(tableId, 'block');
            } else {
                dtObject.toggleViewInfoMessage(tableId, 'none');
            }

            if (!breakpoint("xs")) {
                setTimeout(function () {
                    dtObject.fixedColumns(tableId, 2);
                }, 0);
            }

            dtObject.applyOverflowCellTitles($('#' + tableId));
        });
    }

    calcTotals(initParams, tableId) {
        let table = $('#' + tableId);
        let columns = initParams.columns;
        
        console.log('=== CALC TOTALS DEBUG ===');
        console.log('Table ID:', tableId);
        
        // Usa la STESSA logica di createFooter per trovare il footer
        let footertr;
        let footer = table.closest('.dataTables_scroll').find('.dataTables_scrollFoot table tfoot');
        
        if (footer.length === 0) {
            // Il footer è direttamente sulla tabella (caso normale)
            footertr = table.find('tfoot tr');
        } else {
            // Il footer è in una tabella con scroll
            footertr = footer.find('tr');
        }
        
        console.log('Footer found:', footertr.length, footertr);
        
        if (footertr.length === 0) {
            console.log('ERROR: Footer not found! Cannot calculate totals.');
            return;
        }
        
        let api = table.dataTable().api();
        var totalColumnsPresents = 0;
        
        columns.forEach(function (column, index) {
            //create the th for the total row
            if (column.total) {
                totalColumnsPresents++;
                console.log('Processing total for column:', column.data, 'at index:', index);
                
                var total = api.column(index, {page: 'current'}).data().reduce(function (a, b) {
                    let numA = parseFloat(a) || 0;
                    let numB = parseFloat(b) || 0;
                    return numA + numB;
                }, 0);
                
                console.log('Calculated total for', column.data, ':', total);
                
                var number = total.toFixed(2) + '';
                var x = number.split('.');
                var x1 = x[0];
                var x2 = x.length > 1 ? ',' + x[1] : '';
                var rgx = /(\d+)(\d{3})/;
                while (rgx.test(x1)) {
                    x1 = x1.replace(rgx, '$1' + '.' + '$2');
                }
                let formattedTotal = x1 + x2;
                
                console.log('Formatted total:', formattedTotal);
                
                // Trova il th corrispondente nel footer e imposta il totale
                let footerTh = footertr.find('th').eq(index);
                if (footerTh.length > 0) {
                    footerTh.html('<strong>' + formattedTotal + '</strong>');
                    console.log('Total set in footer th at index:', index);
                } else {
                    console.log('ERROR: Footer th not found at index:', index);
                }
            }
        });
        
        console.log('Total columns processed:', totalColumnsPresents);
        console.log('=== END CALC TOTALS DEBUG ===');
    }

    createFooter(initParams, tableId) {
        let table = $('#' + tableId);
        
        console.log('=== CREATE FOOTER DEBUG ===');
        console.log('Table ID:', tableId);
        console.log('Columns:', initParams.columns);
        
        // Controlla se ci sono colonne con totali
        let hasTotalColumns = initParams.columns.some(column => {
            console.log('Column:', column.data, 'has total:', !!column.total);
            return column.total;
        });
        
        console.log('Has total columns:', hasTotalColumns);
        
        if (!hasTotalColumns) {
            console.log('No total columns found, skipping footer creation');
            return; // Non creare footer se non ci sono totali
        }
        
        // Cerca il footer prima nelle tabelle con scroll, poi in quelle normali
        let footer = table.closest('.dataTables_scroll').find('.dataTables_scrollFoot table tfoot');
        let targetTable = table;
        
        if (footer.length === 0) {
            footer = table.find('tfoot');
            if (footer.length === 0) {
                // Crea il footer direttamente sulla tabella
                footer = $('<tfoot><tr></tr></tfoot>');
                table.append(footer);
                console.log('Created new footer on table');
            } else {
                footer.empty().append('<tr></tr>');
                console.log('Using existing footer on table');
            }
        } else {
            // Footer in tabella con scroll
            targetTable = footer.closest('table');
            footer.empty().append('<tr></tr>');
            console.log('Using footer in scroll table');
        }

        // Trova le colonne dell'header per replicare la struttura
        var headerColumns = table.find('thead tr:last th');
        console.log('Header columns found:', headerColumns.length);

        headerColumns.each(function (index) {
            let th = $(this);
            if (th.is(':visible')) {
                footer.find('tr').append('<th>&nbsp;</th>');
            }
        });
        
        // Crea una riga footer con celle vuote
        let footerRow = $('<tr>');
        for (let i = 0; i < headerColumns.length; i++) {
            footerRow.append('<th></th>');
        }
        footer.append(footerRow);
        
        console.log('Footer created for table:', tableId, 'Footer length:', footer.length);
        console.log('=== END CREATE FOOTER DEBUG ===');
        
        // Chiama calcTotals DOPO aver creato il footer
        setTimeout(() => {
            console.log('Calling calcTotals after footer creation...');
            this.calcTotals(initParams, tableId);
        }, 50);
    }

    fixedColumns(tableId, fixedCount) {
        let tableData = $('#' + tableId);
        let tableHeader = $('#' + tableId).closest('.dataTables_scroll').find('.dataTables_scrollHead table');
        let tableFooter = $('#' + tableId).closest('.dataTables_scroll').find('.dataTables_scrollFoot table');

        let leftWidth = 0;
        for (let i = 1; i <= fixedCount; i++) {
            tableHeader.find('th:nth-child(' + i + ')').each(function () {
                let cell = $(this);

                cell.css('position', 'sticky');
                cell.css('left', leftWidth);
                cell.css('background-color', '#ffffff !important');
                cell.css('z-index', 1);
            });


            tableFooter.find('th:nth-child(' + i + ')').each(function () {
                let cell = $(this);

                cell.css('position', 'sticky');
                cell.css('left', leftWidth);
                cell.css('background-color', '#ffffff !important');
                cell.css('z-index', 1);
            });

            tableData.find('td:nth-child(' + i + ')').each(function () {
                let cell = $(this);
                let row = cell.closest('tr');

                cell.css('position', 'sticky');
                cell.css('left', leftWidth);
                let backColor = row.css('background-color');
                if (backColor != "rgb(249, 249, 249)") {
                    backColor = '#ffffff'
                }
                cell.css('background-color', backColor);
                cell.css('z-index', 1);

                row.hover(function () {
                    cell.css('background-color', '#dff0d8');
                }, function () {
                    cell.css('background-color', backColor);
                });
            });

            leftWidth = leftWidth + 1 + tableHeader.find('th:nth-child(' + i + '):first').width();
        }

    }

    tablePageLenght(tableId) {
        let table = $('#' + tableId);
        //read the page length from the local storage
        let savedParams = localStorage.hasOwnProperty(tableId) ? JSON.parse(localStorage.getItem(tableId)) : null;
        if(savedParams){
            let pageLength = savedParams.hasOwnProperty('pageLength') ? savedParams.pageLength : 0;
            let select = $('select[name=' + tableId + '_length]');
            return pageLength;
        } else {
            return 0;
        }





    }

    listenForChange(tableId) {

        var pageLength;
        let select = $('select[name=' + tableId + '_length]');
        let savedParams = localStorage.hasOwnProperty(tableId) ? JSON.parse(localStorage.getItem(tableId)) : null;

        //on change of the page length select box
        select.on('change', function () {
            pageLength = $(this).val();
            //save the page length to the local storage

            savedParams.pageLength = pageLength;
            localStorage.setItem(tableId, JSON.stringify(savedParams));
        });
    }

    columnsVisibilityFilter() {

        let dtColVisibilityFilters = $('.dt_col_visibility_filter');

        $(dtColVisibilityFilters).on('ifCreated', function () {
            let tableId = $(this).data('table_target');
            let column_target = $(this).data('column_target');
            let initTableParams = $('#' + tableId).data('params');

            if (initTableParams.hasOwnProperty('ignoreLocalStorage') && initTableParams.ignoreLocalStorage == true) {
                for (let c in initTableParams.columns) {
                    let column = initTableParams.columns[c];

                    if (('.dt_col_' + column.data) != column_target) {
                        continue;
                    }

                    if (column.hasOwnProperty('visible') && column.visible == false) {
                        $(this).prop('checked', false).iCheck('update');
                    } else {
                        $(this).prop('checked', true).iCheck('update');
                    }

                    break;
                }

                return;
            }

            let savedParams = localStorage.hasOwnProperty(tableId) ? JSON.parse(localStorage.getItem(tableId)) : null;

            if (!savedParams || !savedParams.hasOwnProperty('visibleCols')) {
                return;
            }

            for (let c in savedParams.visibleCols) {
                let isVisible = savedParams.visibleCols[c].visible;

                if (savedParams.visibleCols[c].column_target != column_target) {
                    continue;
                }

                if (isVisible == 'false' || !isVisible) {
                    $(this).prop('checked', false).iCheck('update');
                } else {
                    $(this).prop('checked', true).iCheck('update');
                }
                break;
            }
        });

        $(dtColVisibilityFilters).iCheck({
            checkboxClass: 'icheckbox_square-green',
            increaseArea: '50%' // optional
        });

        $('.select_all_dt_column_visibility').click(function () {
            let tableTarget = $(this).data('table_target');
            $('.dt_col_visibility_filter[data-table_target="' + tableTarget + '"]').prop('checked', true).iCheck('update');
        });

        $('.unselect_all_dt_column_visibility').click(function () {
            let tableTarget = $(this).data('table_target');
            $('.dt_col_visibility_filter[data-table_target="' + tableTarget + '"]').prop('checked', false).iCheck('update');
        });

        $('body').on('click', '.apply_dt_column_visibility', function (evt) {
            evt.preventDefault();

            let tableTarget = $(this).data('table_target');
            let checkBoxes = $('.dt_col_visibility_filter[data-table_target="' + tableTarget + '"]');
            let savedParams = localStorage.hasOwnProperty(tableTarget) ? JSON.parse(localStorage.getItem(tableTarget)) : {};
            let newParams = {
                searchCols: [],
                order: [],
                visibleCols: [],
                last_used_view: savedParams.hasOwnProperty('last_used_view') ? savedParams.last_used_view : null,
            };
            let newIndex = 0;
            let selectedView = $('select[name="view"][data-target_table="' + tableTarget + '"]').val();
            let form = $(this).parent('form');

            checkBoxes.each(function () {
                let visible = $(this).is(':checked');
                let columnTarget = '.dt_col_' + $(this).data('column_target');
                let savedIndex = null;

                _.forEach(savedParams.visibleCols, function (sVC, index) {
                    if (sVC.column_target === columnTarget) {
                        savedIndex = index;
                        let tmpVC = sVC;
                        tmpVC.visible = visible ? "true" : "false";
                        newParams.visibleCols.push(tmpVC);
                        newParams.searchCols.push(savedParams.searchCols[index]);
                        return false;
                    }
                });

                _.forEach(savedParams.order, function (sO, index) {
                    if (sO[0] == savedIndex) {
                        newParams.order.push([newIndex.toString(), sO[1]]);
                    }
                });

                newIndex++;
            });

            localStorage.setItem(tableTarget, JSON.stringify(newParams));

            form.find('input[name="target_table"]').val(tableTarget);
            form.find('input[name="table_params"]').val(JSON.stringify(newParams));
            form.find('input[name="view_name"]').val(selectedView);
            
            // Trigger evento per aggiornare filtri nella modale quando cambia visibilità colonne
            $(document).trigger('columns-visibility-changed', {
                tableTarget: tableTarget
            });
            
            form.submit();
        })
    }


    tableViewFilter(tableId) {
        let dtObject = this;
        let select2CreateTag = $('.select2-create_tag');
        let saveBtns = $('.dt_save-view_btn');
        let deleteBtns = $('.dt_delete-view_btn');

        select2CreateTag.each(function () {
            let current = $(this);

            current.select2({
                tags: true,
                allowClear: false,
                placeholder: current.data('placeholder'),
                createTag: function (params) {
                    // Mostra sempre i pulsanti Salva/Elimina anche per vista Default
                    // Gli utenti possono personalizzare anche la vista Default ereditata dal super-admin
                    if (params.term == '' || !params.term) {
                        // Se non c'è un nuovo termine, mostra i pulsanti per la vista corrente
                        dtObject.showViewActions(current.data('target_table'));
                    } else {
                        // Se c'è un nuovo termine, mostra i pulsanti per la nuova vista
                        dtObject.showViewActions(current.data('target_table'));
                    }

                    return {
                        id: params.term,
                        text: params.term + " (" + _t('New') + ")",
                    }
                }
            });
        });

        select2CreateTag.on('change', function (evt, autoTriggered) {
            evt.preventDefault();
            if (autoTriggered) {
                return;
            }
            let selected = $(this).find(":selected");
            let selectedVal = selected.val();
            let selectedText = selected.text();

            if (selectedVal !== 'Default' && selectedVal !== selectedText) {
                return;
            }

            let form = $(this).closest('form');
            let targetTable = $(this).data('target_table');
            let savedParams = localStorage.hasOwnProperty(targetTable) ? JSON.parse(localStorage.getItem(targetTable)) : null;
            let viewName = $(this).val();
            
            
            form.find('input[name="table_params"]').val(JSON.stringify(savedParams));
            
            
            // Non rimuovere il localStorage quando si cambia vista - i parametri devono rimanere
            // per permettere alla nuova vista di essere caricata correttamente dopo il reload
            // localStorage.removeItem(targetTable);

            form.submit();
        });

        saveBtns.on('click', function (evt) {
            evt.preventDefault();

            let current = $(this);
            let selectTargetID = current.data('target_select');
            let selectTarget = $('#' + selectTargetID);
            let viewName = selectTarget.val();
            let form = current.closest('form');
            let targetTable = current.data('table_target');
            let savedParams = localStorage.hasOwnProperty(targetTable) ? JSON.parse(localStorage.getItem(targetTable)) : {};
            form.find('input[name="view_name"]').val(viewName);
            form.find('input[name="table_params"]').val(JSON.stringify(savedParams));

            form.submit();
        });

        deleteBtns.on('click', function (evt) {
            evt.preventDefault();

            let current = $(this);

            Swal.fire({
                text: _t('Are you sure you want to remove the selected table view?'),
                icon: "warning",
                buttonsStyling: false,
                showCancelButton: true,
                cancelButtonText: _t('Cancel'),
                confirmButtonText: _t('Delete'),
                customClass: {
                    confirmButton: 'btn btn-danger',
                    cancelButton: 'btn btn-default',
                }
            }).then(function (result) {
                if (result.value) {
                    let selectTargetID = current.data('target_select');
                    let selectTarget = $('#' + selectTargetID);
                    let viewName = selectTarget.val();
                    let form = current.closest('form');
                    let targetTable = current.data('table_target');
                    form.find('input[name="view_name"]').val(viewName);
                    
                    // Non rimuovere il localStorage quando si cancella una vista - la cancellazione
                    // deve essere gestita solo lato backend, mantenendo i parametri correnti
                    // localStorage.removeItem(targetTable);

                    form.submit();
                }
            });
        })
    }

    onCreatedRow(property, row, data, dataIndex) {

    }

    resize(selector) {
        $(selector).each(function () {
            if ($.fn.DataTable.isDataTable($(this))) {
                $(this).DataTable().columns.adjust().draw();
            }
        });
    }

    updateSortIcons(tableId) {
        var $wrapper = $('#' + tableId).closest('.dataTables_wrapper');
        var $headers = $wrapper.find('.dataTables_scrollHead th[class*="sorting"]');
        if ($headers.length === 0) {
            $headers = $wrapper.find('th[class*="sorting"]').not('.dataTables_scrollBody th');
        }

        // Nasconde il thead clone nel scrollBody: lo scrolliamo fuori dalla viewport
        // e aggiungiamo pointer-events:none per evitare che su Safari intercetti click
        // destinati alle righe dati sottostanti (Safari può resettare scrollTop con position:sticky).
        var $scrollBody = $wrapper.find('.dataTables_scrollBody');
        $scrollBody.css('border-top', 'none');
        var $bodyThead = $scrollBody.find('> table > thead');
        if ($bodyThead.length) {
            $scrollBody[0].scrollTop = $bodyThead[0].offsetHeight;
            $bodyThead.css({
                'pointer-events': 'none',
                'user-select': 'none'
            });
        }

        var baseStyle = 'position:absolute;right:8px;top:50%;transform:translateY(-50%);width:0;height:0;pointer-events:none;border-left:4px solid transparent;border-right:4px solid transparent;';

        $headers.each(function () {
            var $th = $(this);
            $th.find('.dt-sort-icon').remove();

            var extraStyle = '';
            if ($th.hasClass('sorting_asc')) {
                extraStyle = 'border-top:6px solid #373737;';
            } else if ($th.hasClass('sorting_desc')) {
                extraStyle = 'border-bottom:6px solid #373737;';
            } else if ($th.hasClass('sorting')) {
                extraStyle = 'border-top:5px solid #9ca3af;';
            } else {
                return;
            }

            $th.css('position', 'relative');
            $th.append('<span class="dt-sort-icon" style="' + baseStyle + extraStyle + '"></span>');
        });
    }

    disableSortingOnFilters(tableId) {
        const $table = $('#' + tableId);
        
        // Aspetta che la tabella sia completamente renderizzata
        if (!$table.hasClass('dataTable')) {
            setTimeout(() => this.disableSortingOnFilters(tableId), 100);
            return;
        }
        
        // Seleziona SOLO la riga dei filtri (prima riga con classe datatable__filters)
        const $filterRow = $table.find('thead tr.datatable__filters');
        
        if ($filterRow.length === 0) {
            return;
        }
        
        // Per ogni TH della riga filtri, disabilita SOLO l'ordinamento DataTables
        $filterRow.find('th').each(function() {
            const $th = $(this);
            
            // Rimuove solo gli eventi di ordinamento DataTables, non tutti gli eventi
            $th.off('click.DT keypress.DT');
            
            // Aggiungi un evento click che previene solo l'ordinamento
            $th.on('click.filterFix', function(e) {
                // Se il click è su un elemento interattivo (input, select, button), lascia che funzioni
                if ($(e.target).is('input, select, button, a, .dt-button') || 
                    $(e.target).closest('input, select, button, a, .dt-button').length > 0) {
                    return; // Non interferire con i controlli dei filtri
                }
                
                // Altrimenti, previeni l'ordinamento
                e.stopPropagation();
                e.preventDefault();
            });
        });
        
        // IMPORTANTE: Assicurati che la seconda riga (titoli delle colonne) mantenga l'ordinamento
        // Rimuovi qualsiasi evento che potrebbe bloccare l'ordinamento
        const $headerRow = $table.find('thead tr').not('.datatable__filters').first();
        if ($headerRow.length > 0) {
            $headerRow.find('th').off('click.filterFix'); // Rimuove l'evento che blocca l'ordinamento
            
            // Assicurati che ogni TH dell'header abbia la classe appropriata per l'ordinamento
            $headerRow.find('th').each(function() {
                const $th = $(this);
                // Rimuovi eventuali classi che potrebbero disabilitare l'ordinamento
                $th.removeClass('no-sort');
                // Assicurati che l'ordinamento sia abilitato
                $th.addClass('sorting');
            });
        }
        
        // Debug: verifica che l'ordinamento sia abilitato
        console.log('🔧 Ordinamento datatable configurato per:', tableId);
        console.log('   - Filtri: ordinamento disabilitato');
        console.log('   - Header: ordinamento abilitato');
        
        // CORREZIONE: Ricalcola le dimensioni delle colonne per evitare disallineamenti
        setTimeout(() => {
            const dataTable = $table.DataTable();
            if (dataTable) {
                dataTable.columns.adjust(); // RIMOSSO .draw() per evitare loop infinito
                console.log('🔧 Colonne ricalcolate per:', tableId);
            }
        }, 100);
    }

    /**
     * Helper per convertire newline in <br> per la visualizzazione nelle DataTables
     * @param {string} text - Il testo contenente caratteri di newline
     * @param {number} maxLength - Lunghezza massima prima del troncamento (opzionale)
     * @returns {string} - Testo con <br> al posto dei newline
     */
    static formatNewlines(text, maxLength = null) {
        if (!text || typeof text !== 'string') {
            return text || '';
        }
        
        let formattedText = text.replace(/\n/g, '<br>');
        
        if (maxLength && formattedText.length > maxLength) {
            formattedText = formattedText.substring(0, maxLength) + '...';
        }
        
        return formattedText;
    }

    /**
     * Helper per rendere una colonna con newline preservati usando CSS
     * Utilizzabile direttamente nelle definizioni delle colonne DataTable
     * @param {string} data - Il dato da visualizzare
     * @param {string} type - Tipo di rendering DataTable
     * @param {object} row - Riga completa dei dati
     * @param {string} className - Classe CSS da applicare (opzionale)
     * @returns {string} - HTML renderizzato con classe CSS appropriata
     */
    static renderWithNewlines(data, type, row, className = 'preserve-newlines') {
        if (type === 'display' || type === 'type') {
            if (!data) return '';
            
            // Escapa caratteri HTML pericolosi ma preserva i newline
            const escaped = $('<div>').text(data).html();
            return '<div class="' + className + '">' + escaped + '</div>';
        }
        return data;
    }

    /**
     * Helper per rendere una colonna convertendo newline in <br>
     * Utilizzabile nelle definizioni delle colonne DataTable
     * @param {string} data - Il dato da visualizzare  
     * @param {string} type - Tipo di rendering DataTable
     * @param {object} row - Riga completa dei dati
     * @param {number} maxLength - Lunghezza massima (opzionale)
     * @returns {string} - HTML renderizzato con <br>
     */
    static renderWithBr(data, type, row, maxLength = null) {
        if (type === 'display' || type === 'type') {
            if (!data) return '';
            
            // Escapa caratteri HTML pericolosi
            const escaped = $('<div>').text(data).html();
            return DataTable.formatNewlines(escaped, maxLength);
        }
        return data;
    }
}

